import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { useLocation, useParams, Outlet } from 'react-router-dom'
import type { Artist, ArtistId } from 'types/artist'
import type { State } from 'types/redux'
import { loadArtist } from '@disco/state-management/actions/artist-actions'
import { getArtist } from '@disco/state-management/selectors/artists'
import { useComposerInsteadOfArtist } from '@disco/utils/composerInsteadOfArtist'
import DocumentHeadTags from 'components/document-head-tags'
import { TabNav } from 'components/ui'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Skeleton from 'components/ui/skeleton'

const LibrariesArtistsArtist = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ artistId: string }>()
  const artistId: ArtistId = parseInt(params.artistId!, 10)
  const artist: Artist = useSelector((state: State) =>
    getArtist(state, artistId),
  )
  const typeData = useComposerInsteadOfArtist().value
  useEffect(() => {
    dispatch(loadArtist(artistId))
  }, [])

  const handleCancel = () => {
    const returnTo = '/catalogs/artists'
    navigate(location.state?.returnTo ?? returnTo)
  }

  const NAV_ITEMS = useMemo(() => {
    const base = '/catalogs/artists'
    let items = [
      {
        label: 'Profile',
        link: {
          pathname: `${base}/${artistId}/profile`,
          state: location.state,
        },
      },
      {
        label: `Linked ${typeData}s`,
        link: {
          pathname: `${base}/${artistId}/linked-artists`,
          state: location.state,
        },
      },
    ]
    return items
  }, [artistId])
  return (
    <ModalWindow
      width="medium"
      header={
        <Heading size={700}>
          {artist && !artist.loading ? (
            `Manage ${typeData} – ${artist.name}`
          ) : (
            <Skeleton />
          )}
        </Heading>
      }
      isOpen={true}
      onClose={handleCancel}
    >
      <DocumentHeadTags title={`Manage ${typeData} | DISCO`} />
      <TabNav className="Tabs--modal" items={NAV_ITEMS} />
      <Outlet />
    </ModalWindow>
  )
}

export default LibrariesArtistsArtist
